import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    divisionLeaderId: string;
    userId: string;
};

export const schemaUserResolver_IsInDivision = z.boolean();

export type SchemaUserResolver_IsInDivision = z.infer<typeof schemaUserResolver_IsInDivision>;

export type UserResolver_IsInDivision = Resolver<Arguments, SchemaUserResolver_IsInDivision>;
